<ion-app
    [class.web-scroll-container]="isWeb"
    dcBgColor="flight-blue-gradient"
    dcGradientDirection="top-to-bottom"
    dcTypography="geist-14">
    <app-splash-overlay></app-splash-overlay>
    <app-party-game-splash-screen-overlay></app-party-game-splash-screen-overlay>
    <app-alerts></app-alerts>
    <app-badge-unlocked-overlay></app-badge-unlocked-overlay>
    <app-in-game-menu></app-in-game-menu>
    <app-event-overlay></app-event-overlay>
    <app-ingame-animation></app-ingame-animation>
    <app-omni-settings-menu></app-omni-settings-menu>
    <app-virt-settings-menu></app-virt-settings-menu>

    <ion-router-outlet id="main" [animated]="!isWeb"></ion-router-outlet>
</ion-app>
